<template>
  <div
    class="page-header header-filter"
    filter-color="black"
  >
    <div
      class="page-header-image"
      style="background-image: url(static/img/background/gillwell-background.jpg)"
    />
    <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-8 col-md-8 ml-auto mr-auto"
            style="text-align:left"
          >
            <wizard
              @complete="wizardComplete"
              @tab-change="onTabChange"
            >
              <template slot="header">
                <h3 class="card-title">
                  Accept Invitation
                </h3>
                <h3 class="description">
                  Use this wizard to accept an invitation to be on a course.
                </h3>
              </template>
              <wizard-tab :before-change="() => validateStep('step1')">
                <template slot="label">
                  <i class="nc-icon nc-email-85" />
                  Invitation
                </template>
                <validate-invite
                  ref="step1"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>

              <wizard-tab :before-change="() => validateStep('step2')">
                <template slot="label">
                  <i class="nc-icon nc-check-2" />
                  Verify
                </template>
                <validate-scouter
                  :invitation-details="invitationDetails"
                  ref="step2"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>

              <wizard-tab
                :before-change="() => validateStep('step3')"
                v-if="!$root.isLoggedIn"
              >
                <template slot="label">
                  <i class="nc-icon nc-single-02" />
                  Register
                </template>
                <register-user
                  ref="step3"
                  :invitation-details="invitationDetails"
                  @on-validated="onStepValidated"
                />
              </wizard-tab>
            </wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validateInvite from './validate-invite.vue'
import validateScouter from './validate-scouter.vue'
import registerUser from './register-user.vue'
import wizard from '@/plugins/paper-components/wizard/simple-wizard.vue'
import wizardTab from '@/plugins/paper-components/wizard/wizard-tab.vue'
import userApi from '@/services/api/user'
import inviteApi from '@/services/api/invitation.js'
import security from '@/services/security.js'

export default {
  name: 'InvitationWizard',
  components: {
    validateInvite,
    validateScouter,
    registerUser,
    wizard,
    wizardTab
  },
  data () {
    return {
      wizardModel: {},
      invitationDetails: {},
      userInfo: {},
      temp1: null,
      temp2: null
    }
  },
  methods: {
    validateStep: function (ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated: function (validated, invitationDetails, userInfo) {
      this.temp1 = invitationDetails
      this.temp2 = userInfo
      this.invitationDetails = invitationDetails ?? this.invitationDetails
      this.userInfo = userInfo ?? this.userInfo
    },
    onTabChange: function (oldTab, newTab) {
      this.$refs.step2.refresh()
    },
    wizardComplete: function () {
      if (this.$root.isLoggedIn) {
        inviteApi.accept(this.$root.scouterKey, this.invitationDetails.ScouterKey)
          .then(x => {
            if (x.ResultCode === 'Success') {
              security.setupCourse(this.$root, this.courseKey)
              security.setupVueSession(this.$root, x, this.courseKey)
              if (this.$root.courseScouterType === 'Participant' && this.$route.path !== '/participant') {
                this.$router.push('/participant')
              } else if (this.$root.courseScouterType === 'Staff' && this.$route.path !== '/staff/dashboard') {
                this.$router.push('/staff')
              }
              this.$emit('wizard-complete')
            } else {
              this.$notify({
                message: x.ResultCode + ': ' + x.ResultMessage,
                icon: 'ti-icon ti-alert',
                type: 'danger',
                horizontalAlign: 'center',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: error,
              icon: 'ti-icon ti-alert',
              type: 'danger',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        return userApi.register(this.userInfo.UserName, this.userInfo.Password
          , this.invitationDetails.CourseKey, this.invitationDetails.ScouterKey, this.invitationDetails.InvitationId)
          .then(response => {
            this.temp1 = response
            if (response.ResultCode !== 'Success') {
              this.$notify({
                message: response.ResultCode + ': ' + response.ResultMessage,
                icon: 'ti-icon ti-alert',
                type: 'danger',
                horizontalAlign: 'center',
                timeout: 2000
              })
            } else {
              const nextPage = security.setupVueSession(this.$root, response)
              this.$router.push(nextPage)
            }
          })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width:680px) {
  .full-page > .content {
    padding-top: 12vh;
  }
}
  .content {
    margin-top: 12%;
  }
  .page-header {
    overflow: hidden;
  }
  .header-filter .container {
    position: relative;
  }
</style>
